<template>
  <div>
    <div v-show="currentPageNews && currentPageNews.length" class="list-top-item">
      <div class="limit-active">
        <h3 class="limit-active-title">
          {{ shelfConfig.title || "资讯攻略" }}
          <button v-show="shelfConfig.linkTabId" class="enter-btn" @click="goMore">更多</button>
        </h3>
        <div class="limit-active-wrap limit-active-list beautiful-skin">
          <div v-for="(news, index) in currentPageNews" :key="'homeNews' + index" @click="goToNews(news)">
            <!-- 只有第一页绑定滚动监听 -->
            <singleNewsHolder
              v-if="currentPageNum == 1"
              v-news-item="scrollItemObserver"
              :news="news"
              :data-seq="index"
              :data-content-id="news.contentId"
              :data-content-type="news.contentType"
              :data-shelf-style="true"
            ></singleNewsHolder>
            <singleNewsHolder v-if="currentPageNum != 1" :news="news"></singleNewsHolder>
          </div>
        </div>
      </div>
      <div v-if="shelfConfig.canChange && numInPage && enableTurn" class="change-btn" @click="turnPageNews('click')">
        <i :class="['change-icon', isNewsLoading ? 'change-icon--spin' : '']"></i>
        <span>换一批</span>
      </div>
    </div>
    <div v-show="(!currentPageNews || !currentPageNews.length) && !shelfConfig.unShowHolder" class="list-top-item list-top-item--loading">
      <div class="limit-active">
        <h3 class="limit-active-title"></h3>
        <div class="limit-active-wrap limit-active-list beautiful-skin">
          <div v-for="(news, index) in placeholderNews" :key="'placeholderNews' + index">
            <singleNewsHolder :news="news"></singleNewsHolder>
          </div>
        </div>
      </div>
      <div
        v-if="shelfConfig.canChange && numInPage && enableTurn"
        class="change-btn"
        style="padding: 0.06rem 0; background: none; border-radius: 0; padding: 0.06rem 0; margin: 0.06rem auto 0.12rem"
        @click="turnPageNews('click')"
      >
        <i class="change-icon"></i>
        <span>换一批</span>
      </div>
    </div>
  </div>
</template>

<script>
import commonSingleNewsHolder from "../basic/commonSingleNewsHolder.vue"
import * as recommendApi from "@api/recommend"
import * as helper from "@utils/helper"
import useDetailItem from "../../mixins/useDetailItem"
import { CLICK, PAGE_VIEW } from "@constants/report-dictonary"
import { reactive, computed, toRefs, onMounted, onUnmounted } from "@vue/composition-api"

export default {
  components: {
    singleNewsHolder: commonSingleNewsHolder
  },

  directives: {
    "news-item": {
      bind(el, binding) {
        if (binding.value) {
          binding.value.observe(el)
        }
      }
    }
  },

  props: {
    shelfConfig: Object,
    propId: String,
    goMoreAction: [Function, undefined]
  },

  setup(props, { root }) {
    const { $route, $store } = root

    const { goToContentDetail, goToOtherTab, getCachedInfo, itemViewsObserver } = useDetailItem(root)

    const data = reactive({
      allNews: {},
      currentPageNews: [],
      currentPageNum: 0,
      placeholderNews: ["", "", "", ""],
      isNewsLoading: false,
      enableTurn: true,
      numInPage: computed(() => {
        return (props.shelfConfig && props.shelfConfig.newsConfig && props.shelfConfig.newsConfig.num) || 0
      }),
      activityId: computed(() => {
        return (props.shelfConfig && props.shelfConfig.newsConfig && props.shelfConfig.newsConfig.activityId) || ""
      }),
      sceneId: computed(() => {
        return (props.shelfConfig && props.shelfConfig.newsConfig && props.shelfConfig.newsConfig.sceneId) || ""
      }),
      operationService: computed(() => {
        return (props.shelfConfig && props.shelfConfig.newsConfig && props.shelfConfig.newsConfig.operationService) || ""
      }),
      operationActivityId: computed(() => {
        return (props.shelfConfig && props.shelfConfig.newsConfig && props.shelfConfig.newsConfig.operationActivityId) || ""
      }),
      recommKey: computed(() => {
        return (props.shelfConfig && props.shelfConfig.newsConfig && props.shelfConfig.newsConfig.recommKey) || ""
      }),
      sandbox: computed(() => $store.state.sandbox),
      pf: computed(() => $store.getters.pf),
      loginState: computed(() => $store.getters.loginState),
      offerId: computed(() => $store.getters.offerId),
      scrollItemObserver: null
    })

    /**
     * 根据页码从data或请求获取内容数据
     */
    const getNewsByPageIndex = pageIndex => {
      if (data.isNewsLoading) return
      if (data.activityId && data.numInPage) {
        data.isNewsLoading = true

        return new Promise((resolve, reject) => {
          if ((data.allNews[pageIndex] && data.allNews[pageIndex].length) || data.allNews[pageIndex] === null) {
            data.isNewsLoading = false
            resolve(data.allNews[pageIndex])
          } else {
            let param = {
              ...helper.getLoginState(data.loginState),
              sandbox: data.sandbox,
              pf: data.pf,
              offerId: data.offerId,
              activity_id: data.activityId,
              sceneId: data.sceneId,
              pageSize: data.numInPage,
              pageIndex: pageIndex
            }
            if (data.operationService) param.operation_service = data.operationService
            if (data.operationActivityId) param.operation_activity_id = data.operationActivityId
            if (data.recommKey) param.recommKey = data.recommKey

            recommendApi
              .getServiceZoneContentRecommendData(param)
              .then(res => {
                data.isNewsLoading = false
                if (res.data && res.data.length > 0) {
                  data.allNews[pageIndex] = res.data
                  resolve(res.data)
                } else if (res.data && res.data.length == 0) {
                  data.allNews[pageIndex] = null
                  //res为空，则为最后一页
                  resolve(null)
                } else {
                  reject(res)
                }
              })
              .catch(err => {
                data.isNewsLoading = false
                reject(err)
              })
          }
        })
      } else {
        return Promise.resolve(null)
      }
    }

    /**
     * 换页
     */
    const turnPageNews = (type = "") => {
      if (data.isNewsLoading) return
      data.currentPageNum += 1

      getNewsByPageIndex(data.currentPageNum).then(res => {
        // 如果最后一页为空，则请求第一页，如果第一页也为空，则不再请求
        if (res === null) {
          data.currentPageNum = 1
          getNewsByPageIndex(data.currentPageNum).then(retryRes => {
            if (retryRes === null) {
              data.enableTurn = false
            } else {
              data.currentPageNews = retryRes
              if (type == "click") {
                // 第一页使用滚动监听上报；后续使用换一批监听上报
                newsViewsReport(data.currentPageNews)
              }
            }
          })
        } else {
          data.currentPageNews = res
          if (type == "click") {
            // 第一页使用滚动监听上报；后续使用换一批监听上报
            newsViewsReport(data.currentPageNews)
          }
        }
      })

      if (data.currentPageNum > 1) {
        // 第一页不算用户点击了换一批
        $store.dispatch("reportUserAction", {
          iformat: CLICK.SERVICEZONE_SHELF_CONTENT_REFRESH,
          pfStructure: $route.query.pfStructure
        })
      }
    }

    const goToNews = content => {
      goToContentDetail({
        content,
        contentType: content.contentType * 1,
        iformat: CLICK.SERVICEZONE_SHELF_CONTENT,
        pfStructure: props.shelfConfig && props.shelfConfig.keyName,
        queryExt: {
          offerId: data.offerId,
          sceneId: data.sceneId
        },
        shelfConfig: {
          pageIndex: data.currentPageNum
        }
      })
    }

    const goMore = () => {
      if (props.shelfConfig.linkTabId) {
        if (props.goMoreAction) {
          props.goMoreAction(props.shelfConfig.linkTabId)
        } else {
          goToOtherTab(props.shelfConfig.linkTabId)
          $store.dispatch("reportUserAction", {
            iformat: CLICK.SERVICEZONE_SHELF_CONTENT_MORE,
            pfStructure: $route.query.pfStructure
          })
        }
      }
    }

    const newsViewsReport = newsList => {
      newsList?.map((news, index) => {
        if (news.contentId) {
          $store.dispatch("reportUserAction", {
            iformat: PAGE_VIEW.SERVICEZONE_NEWS_SHELF_SINGLE,
            pfStructure: $route.query.pfStructure,
            resultInfo: {
              contentId: news.contentId,
              type: news.contentType,
              index: index
            }
          })
        }
      })
    }

    onMounted(() => {
      data.scrollItemObserver = itemViewsObserver()
    })

    onUnmounted(() => {
      data.scrollItemObserver.disconnect()
    })

    // created
    if (props.shelfConfig && props.shelfConfig.type && props.shelfConfig.type.indexOf("news") > -1) {
      // 判断为资讯货架
      // 请求资讯标签
      getCachedInfo().then(res => {
        if (res?.pageIndex) {
          data.currentPageNum = res.pageIndex - 1
        }
        turnPageNews()
      })
    }

    return {
      ...toRefs(data),
      getNewsByPageIndex,
      turnPageNews,
      goToNews,
      goMore,
      goToContentDetail,
      goToOtherTab,
      getCachedInfo,
      newsViewsReport,
      itemViewsObserver
    }
  }
}
</script>
